import { parse, format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

export function FormatStringAsShortDate(string: string | null | undefined): string | null {
	if (string == null) return null;

	var date = new Date(string);

	return format(date, 'MM/dd/yyyy');
}

export function DisplayDateOnly(string: string | null | undefined): string | null {
	if (string == null) return null;

	var parts = string.split('-');
	if (parts.length < 2) return string;

	return `${parts[1]}/${parts[2]}/${parts[0]}`;
}

export function FormatStringAsLongDate(string: string | null | undefined): string | null {
	if (string == null) return null;

	var date = new Date(string);

	return format(utcToZonedTime(date, 'America/New_York'), 'MM/dd/yyyy hh:mm:ss aa');
}

export function ParseDate(string: string | null | undefined): Date | null {
	if (string == null) return null;

	return new Date(string);
}

export function ParseDateOnly(string: string | null | undefined): Date | null {
	if (string == null || string === '') return null;

	return parse(string, 'yyyy-MM-dd', new Date());
}

export function validateDateWithinPlusMinus100Years(value: Date | string | null, fieldLabel: string): string | undefined {
	if (!value) return undefined;

	const date = value instanceof Date ? value : new Date(value);
	if (Number.isNaN(date.getTime())) return `${fieldLabel} is invalid.`;

	const today = new Date();
	today.setHours(0, 0, 0, 0);

	const min = new Date(today);
	min.setFullYear(today.getFullYear() - 100);

	const max = new Date(today);
	max.setFullYear(today.getFullYear() + 100);

	date.setHours(0, 0, 0, 0);

	if (date < min || date > max) {
		return `${fieldLabel} must be within 100 years of today.`;
	}

	return undefined;
}